import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import LicensePlate from 'vue-license-plate';
import 'vue-license-plate/lib/licensePlate.css';

// import Vant from 'vant';
// import 'vant/lib/index.css';

// Vue.use(Vant);

Vue.config.productionTip = false;
Vue.use(LicensePlate);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
